// extracted by mini-css-extract-plugin
export default {"main":"rules_main__6WhHK","age_restriction":"rules_age_restriction__8NTQ6","statements":"rules_statements__NTTsf","policy":"rules_policy__bHndZ","help":"rules_help__f2Qbf"};